import "../auth.scss";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "common/InputForm";
import { loginApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import useButtonLoader from "../../../hooks/useButtonLoader";
import usePasswordToggle from "../../../hooks/usePasswordToggle";
import { LogoImg2 } from "../../../assets/images";
import { auth } from "validation/schema/auth";
import { ValidateInput } from "validation/index";
import { getToken } from "config/axiosInstance";
import useUser from "hooks/useUser";

const checkLandingModule = (user) => {
  if (user?.role?.name?.includes("SUPER_ADMIN")) {
    return "/dashboard"
  }

  if (user?.role?.resources?.includes("dashboard.read")) {
    return "/dashboard"
  } else if (user?.role?.resources?.includes("user.read") || user?.role?.resources?.includes("user.write")) {
    return "/user-management"
  } else if (user?.role?.resources?.includes("content.read") || user?.role?.resources?.includes("content.write")) {
    return "/content-management"
  } else if (user?.role?.resources?.includes("Recipe.read") || user?.role?.resources?.includes("Recipe.write")) {
    return "/recipe-management"
  } else if (user?.role?.resources?.includes("articles.read") || user?.role?.resources?.includes("articles.write")) {
    return "/article-management"
  } else if (user?.role?.resources?.includes("subscription.read") || user?.role?.resources?.includes("subscription.write")) {
    return "/subscription-management"
  } else if (user?.role?.resources?.includes("activity.read") || user?.role?.resources?.includes("activity.write")) {
    return "/activity-management"
  } else {
    return "/dashboard"
  }
}

const LoginPage = ({ setSteps, data, setData }) => {
  const { user, setUser } = useUser();
  const navigationRoute = useNavigate();
  const [error, setError] = useState({ email: "", password: "" });
  const [buttonLoader, setButtonLoader] = useButtonLoader("Login");
  const [inputType, icon] = usePasswordToggle();

  // on change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  // Input Validtion
  const validation = () => {
    const { errors, status } = ValidateInput(data, "loginSchema", auth, null);
    setError(errors);
    return status;
  };

  // Login Handler function
  const loginHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      try {
        setButtonLoader(true);
        const { data: responseData, status } = await loginApi(data);
        if (status === 200) {
          localStorage.setItem(
            "baby_glow_admin_token",
            JSON.stringify(responseData?.data.token)
          );
          setUser(responseData?.data.user);
          toastMessage(responseData?.message, "success", "You have successfully logged in");
          navigationRoute("/dashboard");
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  useEffect(() => {
    if (getToken()) {
      // setTimeout(() => {
      //   window.location.replace("/dashboard");
      // }, 500);
      // console.log({ user });

      // console.log({ddd: checkLandingModule(user)});

      // window.location.reload(checkLandingModule(user));
      // navigationRoute(checkLandingModule(user));
      navigationRoute("/dashboard");
    }
  }, [user]);

  return (
    <>
      <form>
        <div className="form_title">
          <img src={LogoImg2} style={{ maxWidth: "70px" }} alt="" />
          <h2>Login to Baby Grow</h2>
        </div>
        <div className="content">
          <div className="form_field">
            <Input
              label="Email*"
              placeholder="Enter Email"
              name="email"
              maxLength={25}
              value={data?.email}
              onChange={handleInputChange}
              error={error?.email}
              extraError={error?.emailErr}
            />
          </div>
          <div className="form_field has_icon">
            <Input
              className={"form-control input"}
              type={inputType}
              label="Password*"
              placeholder="Enter Password"
              name="password"
              maxLength={25}
              value={data?.password}
              onChange={handleInputChange}
              error={error?.password}
            />
            <span className="password_icons">{icon}</span>
          </div>
          <div className="button_wrap">
            <button
              type="button"
              ref={buttonLoader}
              className="w-100 button"
              onClick={loginHandler}
            >
              Login
            </button>

            <Link to="" onClick={() => {
              setSteps(3);
              setData({});
            }}>
              Forgot Password?
            </Link>
          </div>
        </div>
      </form>
    </>
  );
};

export default LoginPage;
